import { toToday, toPeriodo } from './informe/helpers'
import { INFORME_STYLES } from './informe/styles'
import { buildPage1 } from './informe/pages/page1'
import { buildPage2 } from './informe/pages/page2'
import { buildPage3 } from './informe/pages/page3'

export const buildInformeHTML = ({
  reportData,
  empleador,
  topDenunciantes,
  topJudiciales,
  topEvolucionSiniestros,
  indicadores,
  tipoAccidentePng = '',
  tipoGravedadPng = '',
  evolucionDenunciasPng = '',
  topRankingSiniestros = null,
  firma = '',
}) => {
  const today = toToday()
  const periodoDesde = toPeriodo(reportData?.fechaDesde)
  const periodoHasta = toPeriodo(reportData?.fechaHasta)
  const totalPages = 3

  const shared = { today, periodoDesde, periodoHasta, totalPages }

  return `<!DOCTYPE html>
<html lang="es">
<head>
  <meta charset="UTF-8">
  <title>Informe Siniestral ${periodoDesde} - ${periodoHasta}</title>
  <style>${INFORME_STYLES}</style>
</head>
<body>
  ${buildPage1({ ...shared, empleador, reportData, indicadores, tipoAccidentePng, tipoGravedadPng, evolucionDenunciasPng })}
  ${buildPage2({ ...shared, empleador, reportData, topRankingSiniestros, topDenunciantes })}
  ${buildPage3({ ...shared, empleador, reportData, topJudiciales, topEvolucionSiniestros, firma })}
</body>
</html>`
}

export const previewInformeHTML = (payload, { targetWindow } = {}) => {
  const html = buildInformeHTML(payload)
  const blob = new Blob([html], { type: 'text/html;charset=utf-8' })
  const url = URL.createObjectURL(blob)
  if (targetWindow) {
    targetWindow.location.href = url
  } else {
    window.open(url, '_blank')
  }
}
